import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTranslation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "-3 -3 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 3.74554V1.44828H8V0H6V1.44828H0V3.74554H9L7 7.00832L6 5.60999H3L5 8.40666L0 11.6694L1.5 14L6.5 10.2711L12 13.5339L12.5 11.2033L8.5 8.40666L12 3.74554H14Z",
		fill: "white"
	})
});
export default SvgTranslation;
